export default "__VITE_ASSET__4c985673__"